import { IUserData, IReportData } from "@/entities";

export class Report implements IReportData {
  readonly id?: number;
  readonly filename?: string;
  readonly status?: string;
  readonly requestDate?: Date | string;
  readonly reportDate?: Date | string;
  readonly expirationDate?: Date | string;
  readonly user?: IUserData;

  constructor(data: IReportData) {
    this.id = data.id;
    this.requestDate = data.requestDate;
    this.reportDate = data.reportDate;
    this.expirationDate = data.expirationDate;
    this.status = data.status;
    this.filename = data.filename;
    this.user = data.user;
  }
}
